import { render, staticRenderFns } from "./ConfigDataMartsAddDataMart.vue?vue&type=template&id=e12882f0&scoped=true&"
import script from "./ConfigDataMartsAddDataMart.vue?vue&type=script&lang=js&"
export * from "./ConfigDataMartsAddDataMart.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDataMartsAddDataMart.vue?vue&type=style&index=0&id=e12882f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12882f0",
  null
  
)

export default component.exports